export const DEFAULT_ASSET_COLOR = "#64748b";

export const ASSET_TYPE_COLORS = {
  "AED（屋外）": "#2563eb",
  "マンホールトイレ": "#7c3aed",
  "海抜表示板": "#0f766e",
  "給水拠点": "#dc2626",
  "公衆電話（災害時無料）": "#ea580c",
  "災害時協力井戸": "#0284c7",
  "消火器ボックス": "#16a34a",
  "消火栓": "#db2777",
  "消防署・消防出張所": "#1d4ed8",
  "消防団詰所": "#6d28d9",
  "消防用ホース格納箱": "#0d9488",
  "津波避難タワー": "#b91c1c",
  "土のう置場": "#d97706",
  "避難場所標識": "#4f46e5",
  "防火水槽標識・表示フタ": "#65a30d",
  "防災行政無線": "#e11d48",
  "防災自動販売機": "#9333ea",
  "防災倉庫": "#475569",
};

export const getAssetTypeColor = (assetType) => ASSET_TYPE_COLORS[assetType] || DEFAULT_ASSET_COLOR;
